<template>
    <div>
    <a :href="mpAuthUrl">Vincular cuenta de Mercado Pago.</a>
    </div>    
</template>

<script>
export default {
    props:{
        details:{
            type: Object,
            default: new Object({})
        },
        mpAuthUrl:{
            type:String,
            default:""
        }
    }
}
</script>

<style lang="scss" scoped>

</style>